import "./bridgeApiKey";

const axios = require("axios");

const { REACT_APP_API_URL, REACT_APP_STRAPI_TOKEN_KEY, REACT_APP_BRIDGE_URL } = process.env;

const getAxiosConfig = () => {
  const token = localStorage.getItem(`${REACT_APP_STRAPI_TOKEN_KEY}`);
  if (!token) {
    return {};
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export async function getProductBySku(sku) {
  return await axios.get(
    `${REACT_APP_API_URL}/productsbysku/${sku}`,
    getAxiosConfig()
  );
}

export async function setProductsRank(body) {
  return await axios.post(
    `${REACT_APP_API_URL}/product-ranks/setrank`,
    body,
    getAxiosConfig()
  );
}

export async function enableWebhook(body) {
  return await axios.post(
    `${REACT_APP_API_URL}/administration/webhooks/enable`,
    body,
    getAxiosConfig()
  );
}
export async function disableWebhook(body) {
  return await axios.post(
    `${REACT_APP_API_URL}/administration/webhooks/disable`,
    body,
    getAxiosConfig()
  );
}
export async function sendEmail(emailType, id, processName) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/email`,
    { emailType, processName },
    getAxiosConfig()
  );
}

export async function getFinanceCsv({ dateFrom, dateTo }) {
  return await axios.get(
    `${REACT_APP_API_URL}/order-shippings/exportfinance?dateFrom=${dateFrom}&dateTo=${dateTo}`,
    getAxiosConfig()
  );
}
export async function getNextPackDate() {
  return await axios.get(
    `${REACT_APP_API_URL}/subscriptions/nextpackdate`,
    getAxiosConfig()
  );
}

export async function getPowerboardStatus(id: string | number) {
  return await axios.get(
    `${REACT_APP_API_URL}/subscriptions/${id}/powerboard-status`,
    getAxiosConfig()
  );
}

export async function syncBillingDates() {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/sync-billing-dates`,
    {},
    getAxiosConfig()
  );
}


export async function exportCarrierDataCSV({ data }) {
  return await axios.post(
    `${REACT_APP_API_URL}/order-shippings/export`,
    data,
    getAxiosConfig()
  );
}
export async function exportPackProjectionDataCSV({ data }) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/project/export`,
    data,
    getAxiosConfig()
  );
}
export async function exportSubscriptionDataCSV({ data }) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/export`,
    data,
    getAxiosConfig()
  );
}

export async function exportProductDataCSV({ data }) {
  return await axios.post(
      `${REACT_APP_API_URL}/products/export`,
      data,
      getAxiosConfig()
  );
}

export async function getForwardSubscriptionData() {
  return await axios.get(
    `${REACT_APP_API_URL}/subscriptions/project`,
    getAxiosConfig()
  );
}

export async function uploadTastingNotesFile(formData) {
  return await axios.post(
    `${REACT_APP_API_URL}/upload`,
    formData,
    getAxiosConfig()
  );
}

export async function uploadProductCoverImage(formData) {
  return await axios.post(
    `${REACT_APP_API_URL}/upload`,
    formData,
    getAxiosConfig()
  );
}
export async function refreshFromPronto(sku) {
  return await axios.post(
    `${REACT_APP_API_URL}/products/refreshfrompronto/${sku}`,
    undefined,
    getAxiosConfig()
  );
}

export async function startBulkRefreshFromPronto() {
  return await axios.post(
    `${REACT_APP_API_URL}/products/refreshfrompronto-all`,
    undefined,
    getAxiosConfig()
  );
}

export async function getBulkRefreshFromProntoStatus() {
  return await axios.get(
    `${REACT_APP_API_URL}/products/refreshfrompronto-all/status`,
    getAxiosConfig()
  );
}

export async function pushToAlgolia(id) {
  return await axios.post(
    `${REACT_APP_API_URL}/products/pushtoalgolia/${id}`,
    undefined,
    getAxiosConfig()
  );
}

export async function syncSingleCMSProductToMeilisearch(masterSku: string) {
  return await axios.post(
    `${REACT_APP_BRIDGE_URL}/products/syncSingleCMSProduct`,
    { masterSku },
    getAxiosConfig()
  );
}

export async function syncSingleProntoProductToMeilisearch(masterSku: string) {
  return await axios.post(
    `${REACT_APP_BRIDGE_URL}/products/syncSingleProntoProduct`,
    { masterSku },
    getAxiosConfig()
  );
}

export async function updateOrderMeta(id,field,value){
  return await axios.post(
      `${REACT_APP_API_URL}/checkouts/updatemeta/${id}`,
      {
        key:field,
        value:value
      },
      getAxiosConfig()
  );
}

export async function pushTagForUpdate(id) {
  return await axios.post(
    `${REACT_APP_API_URL}/products/updatebytag/${id}`,
    { undefined },
    getAxiosConfig()
  );
}
export async function pushAttributeForUpdate(id) {
  return await axios.post(
    `${REACT_APP_API_URL}/products/updatebyattribute/${id}`,
    undefined,
    getAxiosConfig()
  );
}

export async function updateStockLevelCache() {
  return await axios.post(
    `${REACT_APP_API_URL}/products/updateStockLevelCache`,
    undefined,
    getAxiosConfig()
  );
}
export async function refreshStockAllocation(id: number) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-runs/stockallocation/refresh`,
    { id },
    getAxiosConfig()
  );
}

export async function pauseSubscription(id: number, body: any) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/pause`,
    body,
    getAxiosConfig()
  );
}
export async function cancelSubscription(id: number, body: any) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/cancel`,
    body,
    getAxiosConfig()
  );
}
export async function restartSubscription(id: number, body: any) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/restart`,
    body,
    getAxiosConfig()
  );
}

export async function processSubscription(id: number) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/processsubscription/${id}`,
    undefined,
    getAxiosConfig()
  );
}

export async function processOrders(orders: number[], body: any) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/orderprocess`,
    { orders, body },
    getAxiosConfig()
  );
}
export async function cancelOrder(order: number, body: any) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/ordercancel`,
    { order, body },
    getAxiosConfig()
  );
}
export async function createOrders(id: string | number) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/createOrders`,
    { id },
    getAxiosConfig()
  );
}
export async function updateOrderHistory(
  id: string | number,
  processName: any
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/updatehistory`,
    { id, processName },
    getAxiosConfig()
  );
}
export async function healSubscriptionOrder(id: string | number) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/${id}/heal`,
    {},
    getAxiosConfig()
  );
}

export async function assignPendingAsapOrder(
  id: string | number,
  runId: string | number,
  processName = "Admin Assign ASAP Order"
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/${id}/assign-run`,
    { runId, processName },
    getAxiosConfig()
  );
}
export async function updateFrequency(
  id: string,
  frequency: any,
  processName: any
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription/updatefrequency`,
    { id, frequency, processName },
    getAxiosConfig()
  );
}
export async function updateSubscriptionPack(
  id: string,
  masterSku: any,
  processName: any
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription/updatepack`,
    { id, masterSku, processName },
    getAxiosConfig()
  );
}

export async function updateNextRunMonth(
  id: string | number,
  nextRunMonth: string,
  processName: string
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/next-run-month`,
    { nextRunMonth, processName },
    getAxiosConfig()
  );
}

export async function bulkUpdatePowerboardStartDate(nextRunMonth: string) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/bulk-update-powerboard-start-date`,
    { nextRunMonth },
    getAxiosConfig()
  );
}

export async function getStuckSubscriptionOrders() {
  return await axios.get(
    `${REACT_APP_API_URL}/subscription-orders/stuck-orders`,
    getAxiosConfig()
  );
}

export async function getOpenSubscriptionRun() {
  return await axios.get(
    `${REACT_APP_API_URL}/subscription-runs?status=open&_limit=1`,
    getAxiosConfig()
  );
}

export async function movePendingOrderToRun(
  orderId: string | number,
  runId: string | number,
  processName: string
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscription-orders/${orderId}/move-to-run`,
    { runId, processName },
    getAxiosConfig()
  );
}

export async function updateBypassPaymentCheck(
  id: string | number,
  bypassPaymentCheck: boolean,
  processName: any
) {
  return await axios.post(
    `${REACT_APP_API_URL}/subscriptions/${id}/toggle-bypass-payment-check`,
    { bypassPaymentCheck, processName },
    getAxiosConfig()
  );
}

export async function updateProductTags({
                                          id,
                                          tags
                                        }:{
  id:string,
  tags:number[]
}) {
  return await axios.put(
      `${REACT_APP_API_URL}/products/${id}`,
      { tags },
      getAxiosConfig()
  );
}

export async function updateProductCustomTags({
                                              id,
                                              customTags,
                                            }:{
  id: string;
  customTags: any[];
}) {
  return await axios.put(
    `${REACT_APP_API_URL}/products/${id}`,
    { customTags },
    getAxiosConfig(),
  );
}

export async function bulkUpdateProductsOnlineStatus({ classes, onlineStatus }: {
  classes: string[];
  onlineStatus: boolean;
}) {
  return await axios.post(
    `${REACT_APP_API_URL}/products/bulk-update-online-status`,
    { classes, onlineStatus },
    getAxiosConfig()
  );
}

export async function fetchConfiguration() {
  const response = await axios.get(
    `${REACT_APP_API_URL}/configuration`,
    getAxiosConfig()
  );

  // Strapi v3 singleType returns the entity directly (not wrapped in data/attributes)
  const raw = response.data;
  if (raw && raw.data && raw.data.attributes) {
    // Fallback in case this is ever migrated to Strapi v4 shape
    return raw.data.attributes;
  }

  return raw || {};
}

export async function updateConfiguration({ disabledAttributeCodes, activeWarehouseCode }: {
  disabledAttributeCodes: string[];
  activeWarehouseCode: string;
}) {
  const existing = await fetchConfiguration();
  return await axios.put(
    `${REACT_APP_API_URL}/configuration`,
    {
      ...existing,
      disabledAttributeCodes,
      activeWarehouseCode,
    },
    getAxiosConfig()
  );
}

export async function getUnsyncedProducts(limit?: number) {
  const url = `${REACT_APP_BRIDGE_URL}/products/unsynced${limit ? `?limit=${limit}` : ''}`;
  return await axios.get(url);
}

export async function rebuildCMSCache() {
  const url = `${REACT_APP_BRIDGE_URL}/products/cache/cms/build`;
  return await axios.post(url);
}

export async function rebuildProntoCache() {
  const url = `${REACT_APP_BRIDGE_URL}/products/cache/pronto/build`;
  return await axios.post(url);
}

export async function invalidateProntoCache() {
  const url = `${REACT_APP_BRIDGE_URL}/products/cache/invalidate`;
  return await axios.post(url);
}

export async function fetchProductDetails(masterSku: string) {
  const url = `${REACT_APP_BRIDGE_URL}/products/details/${masterSku}`;
  return await axios.get(url);
}

export async function getBridgeSyncStatus() {
  const url = `${REACT_APP_BRIDGE_URL}/products/sync/status`;
  return await axios.get(url);
}

export async function syncBulkProducts(masterSkus: string[]) {
  // Use the existing refreshFromPronto function for each SKU
  const results = await Promise.allSettled(
    masterSkus.map(sku => refreshFromPronto(sku))
  );
  
  return {
    data: {
      results: results.map((result, index) => ({
        masterSku: masterSkus[index],
        status: result.status === 'fulfilled' ? 'success' : 'error',
        error: result.status === 'rejected' ? result.reason?.message || 'Unknown error' : null
      })),
      summary: {
        total: masterSkus.length,
        success: results.filter(r => r.status === 'fulfilled').length,
        errors: results.filter(r => r.status === 'rejected').length
      }
    }
  };
}
export async function getBridgeTaskHistory(limit?: number) {
  const url = `${REACT_APP_BRIDGE_URL}/products/task-history${limit ? `?limit=${limit}` : ""}`;
  return await axios.get(url);
}

export async function getBridgeTaskStats() {
  const url = `${REACT_APP_BRIDGE_URL}/products/task-stats`;
  return await axios.get(url);
}

export async function abortBridgeTask(jobId: string, type: "cms" | "pronto") {
  const endpoint = type === "cms" ? "stopJob" : "stopJob"; // Currently both use the same endpoint but distinguished by type
  const url = `${REACT_APP_BRIDGE_URL}/products/${endpoint}/${jobId}`;
  return await axios.post(url);
}

export async function retryBridgeTask(jobId: string, type: "cms" | "pronto") {
  const url = `${REACT_APP_BRIDGE_URL}/products/retry-job/${jobId}`;
  return await axios.post(url);
}

export async function runBridgeSync(syncType: "full" | "test" = "full") {
  const url = `${REACT_APP_BRIDGE_URL}/products/syncCMSProductsToMeilisearch`;
  return await axios.post(url, { syncType });
}

export async function syncBundlesToMeilisearch() {
  const url = `${REACT_APP_BRIDGE_URL}/products/sync-bundles`;
  return await axios.post(url);
}

export async function getBridgeStockBySku(sku: string) {
  const url = `${REACT_APP_BRIDGE_URL}/products/stock/${sku}`;
  return await axios.get(url);
}

export async function getBridgeStockStats() {
  const url = `${REACT_APP_BRIDGE_URL}/products/stock-stats`;
  return await axios.get(url);
}

export async function findDuplicateDrafts() {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/find`;
  return await axios.get(url);
}

export async function findDraftDuplicates() {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/drafts/find`;
  return await axios.get(url);
}

export async function getDraftScanStatus(taskId: string) {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/drafts/status/${taskId}`;
  return await axios.get(url);
}

export async function cleanupDuplicateDrafts(productIds: string[]) {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/cleanup`;
  return await axios.post(url, { productIds });
}

export async function getCleanupStatus(taskId: string) {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/cleanup/status/${taskId}`;
  return await axios.get(url);
}

export async function getSuppressedProducts(filters?: { minPrice?: number; maxPrice?: number; noImage?: boolean }) {
  const url = `${REACT_APP_BRIDGE_URL}/products/suppressed`;
  return await axios.get(url, { params: filters });
}

export async function startPriceSync(productIds: string[]) {
  const url = `${REACT_APP_BRIDGE_URL}/products/price-sync`;
  return await axios.post(url, { productIds });
}

export async function findMeilisearchDuplicates() {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/meilisearch/find`;
  return await axios.get(url);
}

export async function cleanupMeilisearchDuplicates(documentIds: string[]) {
  const url = `${REACT_APP_BRIDGE_URL}/products/duplicates/meilisearch/cleanup`;
  return await axios.post(url, { documentIds });
}

export async function findVisibilityConflicts(filters: { minPrice?: number; maxPrice?: number; noImage?: boolean }) {
  const url = `${REACT_APP_BRIDGE_URL}/products/visibility/find`;
  return await axios.get(url, { params: filters });
}

export async function deactivateVisibility(productIds: string[]) {
  const url = `${REACT_APP_BRIDGE_URL}/products/visibility/deactivate`;
  return await axios.post(url, { productIds });
}

/**
 * Generic AI image generation via OpenRouter (Nano Banana).
 *
 * @param params.prompt — text description of the desired image
 * @param params.inputReferences — optional array of image URLs (up to 14)
 * @param params.aspectRatio — optional, default "1:1"
 * @param params.resolution — optional, default "1K"
 * @param params.ref — optional Strapi model name (e.g. "product-bundles")
 * @param params.refId — optional Strapi record id
 * @param params.field — optional Strapi field name (e.g. "coverImage")
 * @returns { success, imageId, imageUrl, cost }
 */
export async function generateImage(params: {
  prompt: string;
  inputReferences?: string[];
  aspectRatio?: string;
  resolution?: string;
  ref?: string;
  refId?: string | number;
  field?: string;
}) {
  return await axios.post(
    `${REACT_APP_API_URL}/ai-image/generate`,
    params,
    getAxiosConfig()
  );
}
